import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { Banner, QueryGridPageProductBannerArgs } from '@hdms/shared/common-types';

interface GridPageProductBannerResponse {
  gridPageProductBanner: Banner;
}

@Injectable({
  providedIn: 'root'
})
export class GridPageProductBannerGqlService extends Query<
  GridPageProductBannerResponse,
  QueryGridPageProductBannerArgs
> {
  override document = gql`
    query GridPageProductBanner($filter: ProductBannerFilterInput, $localization: LocalizationInput!) {
      gridPageProductBanner(filter: $filter, localization: $localization) {
        id
        overline
        headline
        mobileHeadline
        subHeadline
        body
        imageUri
        layout
        links {
          uri
          label
        }
        webAnalyticsData {
          trackCreative
          trackId
          trackName
        }
      }
    }
  `;
}
